import {
  Component,
  OnInit,
  ContentChildren,
  QueryList,
  AfterContentInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { WizardItem } from './../wizard-item';
import { WizardStepComponent } from './../wizard-step/wizard-step.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'eq-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, AfterContentInit, OnChanges {
  @Input() activeIndex = 0;
  @Input() vertical: boolean;
  @Input() readonly = true;
  @Output() onActiveIndexChange: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  items: WizardItem[] = [];

  @ContentChildren(WizardStepComponent) steps: QueryList<WizardStepComponent>;

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.steps.toArray().map((step: WizardStepComponent, index: number) => {

      if (index === this.activeIndex) {
        step.active = true;
      }

      this.items[index] = {
        label: step.label,
        command: (event: any) => {
          this.steps.toArray().map((s: WizardStepComponent) => s.active = false);
          step.active = true;
          this.activeIndex = index;
          this.onActiveIndexChange.emit(index);
          this.onChange.next(step.label);
        }
      };
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.steps) {
      return;
    }
    Object.keys(changes).map((i) => {
      if (i === 'activeIndex') {
        const currentIndex = changes[i].currentValue;
        this.steps.toArray().forEach((step: WizardStepComponent, index: number) => {
          const selected = index === currentIndex;
          step.active = selected;
          if (selected) {
            this.onChange.next(step.label);
          }
        });
      }
    });
  }

  back() {
    this.activeIndex--;
    this.onActiveIndexChange.emit(this.activeIndex);
    this.ngOnChanges({
      activeIndex: {
        currentValue: this.activeIndex,
        previousValue: this.activeIndex + 1,
        firstChange: false,
        isFirstChange: () => false
      }
    });
  }

  next() {
    this.activeIndex++;
    this.onActiveIndexChange.emit(this.activeIndex);
    this.ngOnChanges({
      activeIndex: {
        currentValue: this.activeIndex,
        previousValue: this.activeIndex - 1,
        firstChange: false,
        isFirstChange: () => false
      }
    });
  }

  confirm() {
    this.onChange.emit(this.activeIndex);
  }
}
